<div class="subject-cad-wrapper" data-testid="subject-cad-wrapper" [ngClass]="{ 'hidden-height': !isSubjectImageOpen }">
  <div class="locations-layer" [class.image-expand]="!isSubjectImageOpen">
    <div
      class="subject-cad-name"
      data-testid="subject-cad-header"
      [class.fixed]="isSubjectImageOpen"
      [ngClass]="{ 'no-subject-image': !structImageSrc }"
      (click)="clickSubjectImageHide()"
      [matTooltip]="subjectModel?.name"
      matTooltipClass="tooltip-overflow"
    >
      <evc-svg-icon id="eye-icon" size="md" icon="visibility-show"></evc-svg-icon>
      <span class="inspection-title">{{ inspectionTitle }}</span>
      <evc-svg-icon
        id="expand-icon"
        data-testid="expand-icon"
        [class.rotated]="isSubjectImageOpen"
        *ngIf="structImageSrc"
        size="md"
        icon="angle-down"
      ></evc-svg-icon>
    </div>
  </div>

  <svg
    [attr.viewBox]="viewBox"
    class="subject-cad-image"
    data-testid="subject-cad-svg"
    [ngClass]="{ 'hidden-image': !isSubjectImageOpen || !structImageSrc }"
    preserveAspectRatio="xMidYMid meet"
  >
    <image
      [attr.href]="structImageSrc"
      x="0"
      y="0"
      [attr.width]="imageWidth"
      [attr.height]="imageHeight"
      preserveAspectRatio="xMidYMid meet"
      style="pointer-events: none"
    ></image>
    <g [class.image-hide]="!isSubjectImageOpen" pointer-events="bounding-box">
      <rect
        *ngFor="let location of subjectLocations"
        [attr.data-testid]="'location-rect-' + location.identifier"
        class="location-area element"
        [class.locationSelected]="filterLocation === location"
        [class.image-hide]="!isSubjectImageOpen"
        [class.selected]="filterLocation === location"
        (click)="onLocationClicked(location)"
        rx="8"
        ry="8"
        [attr.y]="(location.rectInStructImage?.top * imageHeight) / 100"
        [attr.x]="(location.rectInStructImage?.left * imageWidth) / 100"
        [attr.width]="(location.rectInStructImage?.width * imageWidth) / 100"
        [attr.height]="(location.rectInStructImage?.height * imageHeight) / 100"
      ></rect>
    </g>
  </svg>
</div>
